import { createContext, useState } from "react";

export const TenantAdministratorContext = createContext();
const TenantAdministratorProvider = ({children}) =>{
    const [showCreateNewTenantAdministratorWindow,setShowCreateNewTenantAdministratorWindow] = useState(null);
    const [tenantAdministrators,setTenantAdministrators] = useState(null);
    const [reloadTenantAdministrators,setReloadTenantAdministrators] = useState(false);
    const [selectedTenantAdministrator,setSelectedTenantAdministrator] = useState(null);
    const [selectedToEditTenantAdministrator,setSelectedToEditTenantAdministrator] = useState(null);
    const [selectedToDeleteTenantAdministrator,setSelectedToDeleteTenantAdministrator] = useState(null);
    return(
        <TenantAdministratorContext.Provider value={{
            showCreateNewTenantAdministratorWindow,setShowCreateNewTenantAdministratorWindow,
            tenantAdministrators,setTenantAdministrators,
            reloadTenantAdministrators,setReloadTenantAdministrators,
            selectedTenantAdministrator,setSelectedTenantAdministrator,
            selectedToEditTenantAdministrator,setSelectedToEditTenantAdministrator,
            selectedToDeleteTenantAdministrator,setSelectedToDeleteTenantAdministrator
        }}>{children}</TenantAdministratorContext.Provider>
    );
};
export default TenantAdministratorProvider;